export class BeanRegularAppraiserREQ{
  constructor(
    public monitoryMoniIdCdMonitoria: number,
    public userUsuaIdCdUsuario: number
  ){}
}
